import React from 'react';
import { Link } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'
// import { makeStyles } from '@material-ui/core/styles';
// import { Fade } from "react-reveal";
import { blue } from '@mui/material/colors'
import InfoIcon from '@mui/icons-material/Info';
import BannerImage from '../resources/images/christian-literature.jpg'
import CorpusNotes from './CorpusNotes';

const Banner = () => {
  const [showCorpusNotes, setShowCorpusNotes] = React.useState(false)

  return (
    <Box sx={{
      fontFamily: 'Roboto, sans-serif',
      // backgroundColor: 'yellow',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '90%',
      margin: 1,
    }}>
      <Box sx={{
        flex: {
          sm: 1,
          lg: 3
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        p: 2
      }}>
        <img src={BannerImage} alt="banner" style={{
          width: '40vmin',
          maxWidth: 240,
          minHeight: 80,
          objectFit: 'contain'
        }} />
      </Box>
      <Box sx={{
        flex: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center'
        }}>
          <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
          }}
          >
            <Typography sx={{
              fontSize: {
                xs: 'larger',
                sm: 'x-large',
                lg: 'xx-large'
              }
            }}>早期基督教文學資料庫</Typography>
            <Button startIcon={<InfoIcon fontSize="small"/>} onClick={() => setShowCorpusNotes(true)} color="primary" sx={{
              fontSize: 'small',
              ml: 2,
            }}>簡介</Button>
          </Box>
          <Typography>The Database of Early Christian Literature</Typography>
        </Box>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}>
          <a href="../">回主頁</a>
        </Box>
      </Box>
      <CorpusNotes open={showCorpusNotes} onClose={() => setShowCorpusNotes(false)}/>
    </Box>
  )
}

export default Banner